import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { Unit } from '../../../helpers/unit';
import { StorageLocation } from './StorageLocation';
import { ACTIVE_WORK_STATUS, COMPLETED_WORK_STATUS, PLANTING_PLAN_TYPE_ID } from '../../../constants';
import { getWorkedAcres } from '../../../interceptors/dashboard';

class ShapeName extends React.Component {
    constructor() {
        super();
        this.unit = Unit.getInstance();
        this.state = {
            shapeName: '',
            shapeStatus: null,
            cropName: '',
            geoRegionShapeId: '',
            isEditMode: false,
            tareFactor: null,
            customerName: ''
        };

        this.previous = {
            shapeName: '',
            tareFactor: null
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleTareFactor = this.handleTareFactor.bind(this);
        this.handleCheckTareFactor = this.handleCheckTareFactor.bind(this);
    }

    componentDidMount() {
        const { drawingTool, shape } = this.props;
        this.previous = {
            ...this.previous,
            shapeName: shape.name,
            shapeStatus: shape.status,
            tareFactor: shape.tareFactor
        };
        this.setState({
            ...this.state,
            shapeName: shape.name,
            shapeStatus: shape.status,
            cropName: shape.cropName,
            customerName: shape.customerName,
            geoRegionShapeId: shape.geoShapeId,
            tareFactor: shape.tareFactor
        });

        drawingTool && drawingTool.addListener("title_save", shape.id, ({ title }) => {
            if (shape && shape.isAutoName) {
                const shapeName = shape.name.split("#")[1] ? `${title.name} #${shape.name.split("#")[1]}` : title.name;
                this.setState({ ...this.state, shapeName, cropName: title.cropName });
            } else this.setState({ ...this.state, cropName: title.cropName });
        });
    }

    handleChange(e) {
        this.setState({ ...this.state, shapeName: e.target.value })
    }

    handleTareFactor(e) {
        const tarePattern = e.target.value.replace(/[-]/g, "");
        if (e.target.value > 100) this.setState({ ...this.state, tareFactor: 100 });
        else this.setState({ ...this.state, tareFactor: tarePattern });
    }

    handleCheckTareFactor(value) {
        if (value > 0 && value <= 100) return value;
        else return 0;
    }

    handleSave(name) {
        if (name === "edit") this.setState({ ...this.state, isEditMode: true });
        else {
            if (name === "cancel") this.setState({ ...this.state, shapeName: this.previous.shapeName, tareFactor: this.previous.tareFactor });
            else if (name === "ok") {
                this.previous = { ...this.previous, shapeName: this.state.shapeName, tareFactor: this.handleCheckTareFactor(this.state.tareFactor) };
                this.props.onEdit({ id: this.props.shape.id, name: this.state.shapeName, tare_factor: this.handleCheckTareFactor(this.state.tareFactor) });
            }
            this.setState({ isEditMode: false });
        }
    }

    componentWillUnmount() {
        this.props.drawingTool && this.props.drawingTool.removeListenerByName(this.props.shape.id);
    }

    render() {
        if (!this.props.children) return;
        const { settings, shape, fieldReport, varietyName, fieldReportRequesting, /* totalAcres */ } = this.props;
        const { area, distance, editable } = shape;
        const { isEditMode, shapeName, shapeStatus, cropName, customerName, geoRegionShapeId, tareFactor } = this.state;
        const totalArea = area ? this.unit.toArea(area, 2) : null;
        const isField = (shape.typeId === 2);
        const isOffload = (shape.typeId === 4);
        const isStorageVisible = isOffload && shapeStatus === 0;
        let totalNetWeight = fieldReport && fieldReport.loads && fieldReport.loads.total_capacity ? fieldReport.loads.total_capacity : 0;
        const totalTareNetWeight = fieldReport && fieldReport.tare && fieldReport.tare.total_capacity ? fieldReport.tare.total_capacity : 0;
        const workedData = fieldReport && fieldReport.summary ? fieldReport.summary : null;

        let completedAcres;
        if (this.props.planTypeId === PLANTING_PLAN_TYPE_ID && workedData) {
            const getAcres = getWorkedAcres(workedData, this.props.range);
            completedAcres = getAcres.workedAcres ? this.unit.toArea(getAcres.workedAcres, 2) : 0;
        } else {
            completedAcres = fieldReport && fieldReport.summary && fieldReport.summary.harvested_acreage ? this.unit.toArea(fieldReport.summary.harvested_acreage, 2) : 0;
        }
        const actualCompletedAcres = this.props.planTypeId === PLANTING_PLAN_TYPE_ID ? totalArea && (completedAcres > totalArea) ? totalArea : completedAcres : completedAcres;
        const workedStatus = shape && shape.geoJSON && shape.geoJSON.workStatus && shape.geoJSON.workStatus.length > 0 ? shape.geoJSON.workStatus : [];
        const lastWorkStatus = workedStatus && workedStatus.length > 0 ? workedStatus[workedStatus.length - 1].work_status : ACTIVE_WORK_STATUS;
        const isCompleted = lastWorkStatus === COMPLETED_WORK_STATUS;

        let totalWeight = 0;

        if (totalNetWeight > 0 && totalTareNetWeight > 0) {
            totalWeight = totalNetWeight - totalTareNetWeight;
        } else {
            totalWeight = totalNetWeight
        }

        let totalAvgWeight = (totalWeight / totalArea);
        let completedAvgWeight = (totalWeight / completedAcres)
        totalAvgWeight = this.unit.toWeight(totalAvgWeight, 2);

        let updatedTareWeigth = (fieldReport && fieldReport.tare && fieldReport.tare.total_capacity) ? this.unit.toWeight(fieldReport.tare.total_capacity, 2) : 0;
        if (updatedTareWeigth === 0) {
            updatedTareWeigth = (fieldReport && fieldReport.loads && fieldReport.loads.total_tare_weight) ? this.unit.toWeight(fieldReport.loads.total_tare_weight, 2) : 0;
        }

        return this.props.children({
            totalArea,
            isField,
            customerName,
            shapeName: <input
                placeholder={isEditMode ? "Shape name" : ""}
                type="text"
                className="text-input"
                onChange={this.handleChange}
                value={shapeName}
                readOnly={!isEditMode}
            />,
            shapeDetail: <>
                {(!isStorageVisible && tareFactor > 0) && <Row className="m-0 row-mb">
                    <Col lg={6} sm={6} md={6} className="p-0 mt-1"><b>Tare %</b></Col>
                    <Col lg={1} sm={1} md={1} className="p-0 mt-1">:</Col>
                    <Col lg={5} sm={5} md={5} className="p-0 mt-1">{
                        isEditMode ?
                            <input
                                placeholder={"Tare factor"}
                                type="number"
                                max="100"
                                min="1"
                                className="tare-factor-text-input"
                                onChange={this.handleTareFactor}
                                value={tareFactor}
                                style={{ width: "60px" }}
                            />
                            : (tareFactor === 0 ? "-" : `${tareFactor} %`)}
                    </Col>
                </Row>}
                {!isStorageVisible && (cropName && cropName.toString().trim().length !== 0) && <Row className="m-0 row-mb">
                    <Col lg={6} sm={6} md={6} className="p-0"><b>Crop</b></Col>
                    <Col lg={1} sm={1} md={1} className="p-0">:</Col>
                    <Col lg={5} sm={5} md={5} className="p-0">{cropName}</Col>
                </Row>}
                {varietyName ? <Row className="m-0 row-mb">
                    <Col lg={6} sm={6} md={6} className="p-0"><b>Variety</b></Col>
                    <Col lg={1} sm={1} md={1} className="p-0">:</Col>
                    <Col lg={5} sm={5} md={5} className="p-0">{varietyName}</Col>
                </Row> : null}
                {isStorageVisible && <StorageLocation geoRegionShapeId={geoRegionShapeId} shapeId={shape.geoShapeRefId} shapeName={shapeName}
                    cropName={cropName} totalArea={totalArea} settings={settings} />}
                {isField && totalArea !== null && <Row className="m-0 row-mb">
                    <Col lg={6} sm={6} md={6} className="p-0"><b>{settings.areaShortName}</b></Col>
                    <Col lg={1} sm={1} md={1} className="p-0">:</Col>
                    <Col lg={5} sm={5} md={5} className="p-0">{totalArea}</Col>
                </Row>}
                {completedAcres && completedAcres > 0 ? <Row className="m-0 row-mb">
                    <Col lg={6} sm={6} md={6} className="p-0"><b>Completed Acres</b></Col>
                    <Col lg={1} sm={1} md={1} className="p-0">:</Col>
                    <Col lg={5} sm={5} md={5} className="p-0">{actualCompletedAcres}</Col>
                </Row> : null}
                {isField && distance !== null && <Row className="m-0 row-mb">
                    <Col lg={6} sm={6} md={6} className="p-0"><b>Distance (meters)</b></Col>
                    <Col lg={1} sm={1} md={1} className="p-0">:</Col>
                    <Col lg={5} sm={5} md={5} className="p-0">{distance}</Col>
                </Row>}
            </>,
            editButton: editable &&
                <span className="btn-action-group">
                    {isEditMode
                        ? <div className='d-flex'>
                            <button onClick={() => this.handleSave("ok")}>
                                <i className="fa fa-check" title="Ok" aria-hidden="true" />
                            </button>
                            <button onClick={() => this.handleSave("cancel")}>
                                <i className="fa fa-close" title="Cancel" aria-hidden="true" />
                            </button></div>
                        : <button onClick={() => this.handleSave("edit")}>
                            <i className="fa fa-pencil" title="Edit" aria-hidden="true" />
                        </button>}
                </span>,
            shapeReport: !fieldReportRequesting ? <>
                {fieldReport && fieldReport.loads && <>
                    <Row className="m-0 row-mb">
                        <Col lg={6} sm={6} md={6} className="p-0 mt-1"><b>Total Loads</b></Col>
                        <Col lg={1} sm={1} md={1} className="p-0 mt-1">:</Col>
                        <Col lg={5} sm={5} md={5} className="p-0 mt-1">{fieldReport.loads.total_loads || 0}</Col>
                    </Row>
                    {/* <Row className="m-0 row-mb">
                        <Col lg={6} sm={6} md={6} className="p-0 mt-1"><b>Total Gross Weight</b></Col>
                        <Col lg={1} sm={1} md={1} className="p-0 mt-1">:</Col>
                        <Col lg={5} sm={5} md={5} className="p-0 mt-1">{fieldReport.loads && fieldReport.loads.total_gross_weight ? this.unit.toWeight(fieldReport.loads.total_gross_weight, 2) : 0} {settings.weightShortName}</Col>
                    </Row> */}
                    {totalWeight && totalWeight > 0 ? <Row className="m-0 row-mb">
                        <Col lg={6} sm={6} md={6} className="p-0 mt-1"><b>Total Net Weight</b></Col>
                        <Col lg={1} sm={1} md={1} className="p-0 mt-1">:</Col>
                        {/* <Col lg={5} sm={5} md={5} className="p-0 mt-1">{fieldReport.loads && fieldReport.loads.total_capacity ? this.unit.toWeight(fieldReport.loads.total_capacity, 2) : 0} {settings.weightShortName}</Col> */}
                        <Col lg={5} sm={5} md={5} className="p-0 mt-1">{totalWeight ? this.unit.toWeight(totalWeight, 2) : 0} {settings.weightShortName}</Col>
                    </Row> : null}
                </>}
                {fieldReport && fieldReport.tare && <>
                    {fieldReport.tare.total_loads > 0 && <Row className="m-0 row-mb">
                        <Col lg={6} sm={6} md={6} className="p-0 mt-1"><b>Total Tare Loads</b></Col>
                        <Col lg={1} sm={1} md={1} className="p-0 mt-1">:</Col>
                        <Col lg={5} sm={5} md={5} className="p-0 mt-1">{fieldReport.tare.total_loads || 0}</Col>
                    </Row>}
                    {/* <Row className="m-0 row-mb">
                        <Col lg={6} sm={6} md={6} className="p-0 mt-1"><b>Total Tare Gross Weight</b></Col>
                        <Col lg={1} sm={1} md={1} className="p-0 mt-1">:</Col>
                        <Col lg={5} sm={5} md={5} className="p-0 mt-1">{fieldReport.tare && fieldReport.tare.total_gross_weight ? this.unit.toWeight(fieldReport.tare.total_gross_weight, 2) : 0} {settings.weightShortName}</Col>
                    </Row> */}
                    {updatedTareWeigth > 0 ? <Row className="m-0 row-mb">
                        <Col lg={6} sm={6} md={6} className="p-0 mt-1"><b>Total Tare Weight</b></Col>
                        <Col lg={1} sm={1} md={1} className="p-0 mt-1">:</Col>
                        <Col lg={5} sm={5} md={5} className="p-0 mt-1">{updatedTareWeigth} {settings.weightShortName}</Col>
                    </Row> : null}
                </>}
                {(totalAvgWeight && totalAvgWeight > 0 && isCompleted) ? <Row className="m-0 row-mb">
                    <Col lg={6} sm={6} md={6} className="p-0 mt-1"><b>Total Acres Avg.Yield</b></Col>
                    <Col lg={1} sm={1} md={1} className="p-0 mt-1">:</Col>
                    <Col lg={5} sm={5} md={5} className="p-0 mt-1">{totalAvgWeight} {settings.weightShortName}</Col>
                </Row> : null}
                {!(this.props.planTypeId === PLANTING_PLAN_TYPE_ID) && fieldReport && fieldReport.summary && <Row className="m-0 row-mb">
                    <Col lg={6} sm={6} md={6} className="p-0 mt-1"><b>Completed Acres Avg.Yield</b></Col>
                    <Col lg={1} sm={1} md={1} className="p-0 mt-1">:</Col>
                    {/* <Col lg={5} sm={5} md={5} className="p-0 mt-1"> {fieldReport.summary && fieldReport.summary.average_hectograms_per_acre && this.unit.toWeight(fieldReport.summary.average_hectograms_per_acre, 2)} {settings.weightShortName}</Col> */}
                    <Col lg={5} sm={5} md={5} className="p-0 mt-1"> {fieldReport.summary && fieldReport.summary.harvested_acreage && this.unit.toWeight(completedAvgWeight, 2)} {settings.weightShortName}</Col>
                </Row>}

            </> : <Row className="m-0 row-mb">
                <Col lg={12} sm={12} md={12} className="p-0 mt-1 text-center">Loading...</Col>
            </Row>,
        });
    }
}

const mapStateToProps = (state) => ({
    settings: state.user.settings,
    range: state.analyze.searchParams.range,
    planTypeId: state.plan.selectedPlanType,
});

export default connect(mapStateToProps)(ShapeName);
